import React from "react";
import PropTypes from "prop-types";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ShoppingCart, ArrowLeft } from "react-feather";
import axios from "axios";
import { base_api_url } from "../../environment.jsx";
import { useEffect, useState } from 'react';


const MenuHeader = ({ showBackButton = false, restauId, Table, cartQuantity = 0, onCartClick }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [restaurant, setRestaurant] = useState(null);
  const [Tables, setTables] = useState(null);
  const isOrderSummaryPage = location.pathname.includes('/order-summary') || location.pathname.includes('/recap');
  const shouldShowBackButton = showBackButton || isOrderSummaryPage;

  const handleBackClick = () => {
    navigate(-1); // Retour à la page précédente
  };

   useEffect(() => {
    if (restauId && Table) {
      fetchRestaurant(restauId);
      fetchTable(Table);
    }
    console.log("restauId :", restauId);
  }, [restauId, Table]);

  const fetchRestaurant = async (restauId) => {
    try {
      const response = await axios.get(`${base_api_url}api/restaurant/${restauId}`);
      setRestaurant(response.data.restaurant);     
    } catch (error) {
      console.error("Erreur lors de la récupération du restaurant :", error);
    }
  };

  const fetchTable = async (Table) => {
    try {
      const response = await axios.get(`${base_api_url}api/tables/${Table}`);
      setTables(response.data.table);
    } catch (error) {
      console.error("Erreur lors de la récupération de la table :", error);
    }
  };

  console.log("Restaurant:", restaurant);
  console.log("Tables:", Tables);

  // Cart icon - button when onCartClick provided, Link otherwise
  const cartIconStyle = {
    color: '#FF6215',
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 0,
  };

  const CartBadge = () => (
    <>
      <ShoppingCart size={20} />
      {cartQuantity > 0 && (
        <span style={{
          position: 'absolute',
          top: '-8px',
          right: '-8px',
          backgroundColor: '#FF6215',
          color: 'white',
          borderRadius: '50%',
          width: '18px',
          height: '18px',
          fontSize: '10px',
          fontWeight: 'bold',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minWidth: '18px'
        }}>
          {cartQuantity}
        </span>
      )}
    </>
  );

  return (
    <div className="menu-header" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      height: '60px',
      backgroundColor: '#fff',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      zIndex: 1000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 20px'
    }}>
      {/* Left Section - Logo ou bouton retour */}
      <div className="logo-section">
        {shouldShowBackButton ? (
          <Link to={`/homemenu?r=${restauId}&t=${Table}`} onClick={handleBackClick} style={{
            fontSize: '24px',
            color: '#FF6215',
            textDecoration: 'none',
            display: 'flex',
            alignItems: 'center'
          }}>
            <ArrowLeft size={24} />
          </Link>
        ) : (
          <Link to="/homemenu" style={{
            fontSize: '24px',
            fontWeight: 'bold',
            color: '#FF6215',
            textDecoration: 'none'
          }}>
          {restaurant && restaurant.logo && (
            <img src={restaurant.logo} alt="Logo" style={{ height: 50 }} />
          )}
          </Link>
        )}
      </div>

      {/* Right Section */}
      <div className="header-right" style={{
        display: 'flex',
        alignItems: 'center',
        gap: '15px'
      }}>
        {/* Icône de panier avec badge */}
        {onCartClick ? (
          <button onClick={onCartClick} style={cartIconStyle}>
            <CartBadge />
          </button>
        ) : (
          <Link to={`/order-summary?r=${restauId}&t=${Table}`} style={cartIconStyle}>
            <CartBadge />
          </Link>
        )}
      </div>
    </div>
  );
};
MenuHeader.propTypes = {
  showBackButton: PropTypes.bool,
  restauId: PropTypes.string,
  Table: PropTypes.string,
  cartQuantity: PropTypes.number,
  onCartClick: PropTypes.func
};

export default MenuHeader;
